import * as R from 'ramda';
import AddressInfo from '../addressInfo';
import {FrenchTypes} from '../../utils/connectionTypes';

export default function Lease(data) {
    let activity = data || {};
    this.type = FrenchTypes.locataire;
    this.address = R.isNil(data) || R.isNil(data.address) ? new AddressInfo() : new AddressInfo(data.address);
    this.name =  activity.name;
}